var render = function render(){var _vm=this,_c=_vm._self._c;return _c('browse-filter',{attrs:{"name":_vm.attribute.name}},_vm._l((_vm.options),function(option){return _c('browse-filter-checkbox',{key:option,attrs:{"label":option,"value":option,"checked":_vm.value.includes(option)},on:{"click":_vm.select}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }